import React, { Component } from 'react';
import {Glyphicon} from 'react-bootstrap';
import { CCOButton, EventApprovalSection } from '../../util/Components.js';
import PanelView from '../../model/PanelView.js';
import {clone, getRoomName, getLeaderName, formatDate, update, toCSV, trimLocation, needsApproval} from '../../util/Utility.js';
import RSVPView from './RSVPView.js';

export default class EventPanelView extends Component {

  constructor(props) {
    super(props);

    this.defaultState = {
      rsvp: false,
      object: null,
    };

    this.state = {
      rsvp: false,
      object: clone(props.objectPass),
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps != this.props) {
      this.setState({object: clone(newProps.objectPass)});
    }
  }

  publish(key) {
    update('events/' + key, this, {published: true})
  }

  sendReminder(key) {
    update('events/' + key, this, {sendReminder: true}).then(() => this.setState({sent: key}));
  }

  render() {

    var object = this.state.object;

    var setup = object.roomSetup ? toCSV(object.roomSetup) : '';
    if (object.techSetup && Object.keys(object.techSetup).length !== 0 && setup !== '') setup += ", ";
    setup += object.techSetup ? toCSV(object.techSetup) : '';
    if (object.setupNotes) {
      setup += (setup ? "; " : "") + object.setupNotes;
    }

    console.warn(this.state.rsvp)

    return (
      <PanelView type="event" edit delete deleteButtonTitle={object.show ? "Cancel" : "Delete"} deleteConfirmationSubtext={object.show ? "Canceled events are marked as 'Canceled' in the app, so that people are informed that the event is no longer taking place." : null} setState={this.setState.bind(this)} object={object} {...this.props}>
        <div>
          <RSVPView show={this.state.rsvp} done={() => this.setState({rsvp: false})} event={object} />
          <center>
            <h2 style={{margin: 0}}>{object.title}</h2>
            <p className="popoverTextHeader">{formatDate(object.date, object.endDate)}</p>
          </center>
          <div style={{height: 7}} />
          <p style={{textAlign: 'left'}}>{object.description}</p>
          <p><Glyphicon glyph="map-marker" /> Located at {object.atCCO ? "CCO in the " + getRoomName(object) : trimLocation(object.location)}</p>
          <p><Glyphicon glyph="user" /> Created By {getLeaderName(object.originator)}</p>
          {object.published ? <EventApprovalSection event={object} /> : <p><Glyphicon glyph="edit" /> Not published yet{needsApproval(object) && ", you need to send it to be approved"}</p>}
          {object.show ? <p><Glyphicon glyph="ok" /> Showing in the app</p> : <p><Glyphicon glyph="remove" /> Not showing in the app</p>}

          <p><b>Setup Needed: </b>{setup || "None"}</p>
          {(object.atCCO || object.techSetup || object.setupNotes) && <div style={{marginBottom: 30, marginTop: 25}}>
            <p>Please download and complete these forms, then send them or give them to Cheri (<a href="mailto:cheri@ccorl.com">cheri@ccorl.com</a>):</p>
            {object.atCCO && <p><a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/ccoapp.appspot.com/o/forms%2FFacility%20Use%20and%20Special%20Event%20Request-2019.pdf?alt=media&token=d0bd22c0-ff6a-4f72-83ec-d21f37f1c4cb">Facility Use and Special Event Request-2019.pdf</a></p>}
            {(object.techSetup || object.setupNotes) && <p><a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/ccoapp.appspot.com/o/forms%2FFacility-AV-Equipment%20%26%20Use%20Request%20Form%20Details%202019.pdf?alt=media&token=4e80319f-c0bb-420c-8647-54055a1194d7">Facility-AV-Equipment &amp; Use Request Form Details 2019.pdf</a></p>}
          </div>}

          <div style={{width: 200}}>
            {!object.published && <div style={{marginBottom: 10}}><CCOButton text={needsApproval(object) ? "Send to be Approved" : "Publish Event"} onClick={this.publish.bind(this, object.key)} type="primary" /></div>}
            {(object.action !== "none") && <div style={{marginBottom: 10}}><CCOButton text={"Show "+ (object.action === "rsvp" ? "RSVP" : "Registered") + " (" + (object.rsvp ? Object.keys(object.rsvp).length : 0) + ")"} onClick={() => this.setState({rsvp: true})} type="primary" /></div>}
            {object.show && <div style={{marginBottom: 10}}><CCOButton onClick={() => this.sendReminder(object.key)} text={object.key !== this.state.sent ? "Send Reminder Notification" : "Notification Sent"} type="primary" /></div>}
          </div>
        </div>
      </PanelView>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/ministry/events/EventPanelView.js
 **/